/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Admin Console
 * Mercatus Admin Console
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Which dashboard type a row is. Immutable once created: a dashboard cannot change type, so an update that names a different type is rejected.
 * @export
 * @enum {string}
 */
export enum DashboardType {
    INSIGHTS = 'INSIGHTS',
    SUMMARY = 'SUMMARY',
    HOMEPAGE = 'HOMEPAGE'
}



